/* Heart Palpitations - EVERGREEN on-demand masterclass sales page (product template product.palp-evergreen)
   Loaded only by the Custom Liquid block on that template.
   Built 2026-09-24. Cart logic copied from the HAP evergreen page, verified live with a paid order 2026-09-15.
   No WebinarJam bridge: evergreen buyers are not registered in WebinarJam. */
(function () {
  var root = document.querySelector('.nhd-palpsale');
  if (!root) return;
  root.classList.add('nhd-js');

  /* Escape Prestige's boxed Container. CSS also covers this with :has(); this is the fallback. */
  var host = root.closest('.shopify-section');
  if (host) host.classList.add('nhd-palpsale-host');

  var VARIANT_ID = parseInt(root.getAttribute('data-palpsale-variant'), 10) || 0;
  var FUNNEL = root.getAttribute('data-palpsale-funnel') || 'palp-evergreen-product';

  /* ----------------------------------------------------------------------
     GET INSTANT ACCESS -> exactly one masterclass in the cart -> /checkout
     If the product is already in the cart (back button, repeat click) the line
     is forced to quantity 1 via change.js instead of adding a second copy.
     Other cart items are left alone. Falls through to /checkout on any error.
  ---------------------------------------------------------------------- */
  function utmContent(placement) {
    try {
      var q = new URLSearchParams(location.search);
      return q.get('utm_content') || placement;
    } catch (e) { return placement; }
  }

  function buy(btn) {
    if (!VARIANT_ID) {
      console.error('[NHD] Masterclass variant id missing. Check that this template is assigned to the masterclass product and that the product has an available variant.');
      return;
    }
    var placement = (btn && btn.getAttribute('data-placement')) || 'unknown';
    if (btn) { btn.disabled = true; }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === VARIANT_ID) { line = cart.items[i]; break; }
        }
        if (line) {
          if (line.quantity === 1) return null;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 1 })
          });
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: VARIANT_ID,
              quantity: 1,
              properties: {
                _funnel: FUNNEL,
                _placement: placement,
                _utm_content: utmContent(placement)
              }
            }]
          })
        });
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/checkout'; });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-palpsale-buy]');
    if (btn) { e.preventDefault(); buy(btn); }
  });

  /* ==== Motion system (Flavia's build, scoped to root) ==== */
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* Sticky bar hides while the final CTA or the legal band is on screen. */
  var bar = root.querySelector('.nhd-sticky');
  var hideOn = root.querySelectorAll('.nhd-final, .nhd-legal');
  var revAnchor = document.getElementById('reviews');
  /* past the #reviews anchor = the Judge.me widget is on screen, so keep the bar hidden */
  function pastReviews() { return !!revAnchor && revAnchor.getBoundingClientRect().top < window.innerHeight; }
  if (bar && hideOn.length && hasIO) {
    var visible = {};
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.id || en.target.className] = en.isIntersecting; });
      var any = false;
      for (var k in visible) { if (visible[k]) any = true; }
      bar.classList.toggle('nhd-hide', any || pastReviews());
    }, { threshold: 0.25 });
    hideOn.forEach(function (el) { sio.observe(el); });
    window.addEventListener('scroll', function () {
      if (pastReviews()) bar.classList.add('nhd-hide');
    }, { passive: true });
  }

  /* Deep link /products/...#reviews: late-loading images shift the page, so land again after load. */
  if (location.hash === '#reviews') {
    window.addEventListener('load', function () {
      var a = document.getElementById('reviews');
      if (a) a.scrollIntoView();
    });
  }

  /* Milestone rail draws once when it scrolls into view. */
  var tracks = root.querySelectorAll('.nhd-track');
  if (still || !hasIO) { tracks.forEach(function (el) { el.classList.add('nhd-drawn'); }); }
  else {
    var tio = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('nhd-drawn'); tio.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
    tracks.forEach(function (el) { tio.observe(el); });
  }

  /* Reveal on scroll. */
  var items = root.querySelectorAll('.nhd-rv,.nhd-rv-l,.nhd-rv-r');
  if (still || !hasIO) { items.forEach(function (el) { el.classList.add('nhd-in'); }); }
  else {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('nhd-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    var seen = {};
    items.forEach(function (el) {
      var k = (el.parentNode.className || 'x'); seen[k] = (seen[k] || 0) + 1;
      el.style.transitionDelay = (Math.min(seen[k] - 1, 5) * 70) + 'ms';
      io.observe(el);
    });
  }

  if (still) return;

  /* Reading progress bar. */
  var pbar = root.querySelector('.nhd-progress'), t = false;
  function frame() {
    t = false;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (pbar && h > 0) pbar.style.transform = 'scaleX(' + Math.min(1, window.scrollY / h) + ')';
  }
  window.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(frame); } }, { passive: true });
  frame();
})();
